import {useQuery} from "@tanstack/react-query";
import {useEffect} from "react";
import {getAuthUser} from "../services/UserService";
import {useLogout} from "./useLogout";

// Full authorization-aware detail for one user (GET /api/v3/auth/users/{id}, TMMFX-3451).
// Returns {user, isLoading, isError, refetch}.
export function useAuthUser(id, enabled = true) {
    const logout = useLogout();
    const {data, isLoading, isError, error, refetch} = useQuery({
        queryKey: ["authUser", id],
        queryFn: () => getAuthUser(id),
        enabled: enabled && !!id,
        retry: false,
    });

    useEffect(() => {
        if (isError && error?.response?.status === 401) {
            logout();
        }
    }, [isError, error]);

    return {user: data ?? null, isLoading, isError, refetch};
}
